import React, { useState } from "react";
import { PencilSquare, Trash, Table } from "react-bootstrap-icons"; // eslint-disable-line
import { useTranslation } from "react-i18next";
import { FilterType } from "components/Reports/reportAssets/assets";
import { SavedFiltersProps, savedFilterType } from "./savedFilter.types";
import { prepareFilterOptions } from "./helper";

const SavedFilters = (props: SavedFiltersProps) => {
  const { t } = useTranslation();
  const {
    setChosenFilter,
    chosenFilter,
    openTheMultiCollapseFormOutSide,
    closeSavedFilterComponent,
    setRunFilter,
    runFilter,
    filterOptionInit,
    setReportDate,
    setUpdateDate,
    setRegistrationDate,
    setLastReportUpdate,
    dbRequest,
    deleteDbRequest,
    filterType,
    submitFilter,
  } = props;

  const deleteFilterFromDB = async (savedFilter) => {
    const deleteRequest =
      filterType === FilterType.reportType
        ? deleteDbRequest?.deleteFilter(savedFilter.id)
        : deleteDbRequest?.deleteFilter({
            idToDelete: savedFilter.id,
            filterType,
          });

    try {
      const res = await deleteRequest;
      if (res.data === false) {
        setMessage(`${t("FailedToSaveFilter")}`);
      } else setMessage(t("DeletedSuccessfully"));
    } catch (err) {
      setMessage(`${t("FailedToSaveFilter")}:${err}`);
    }

    clearFilter();
    setTimeout(() => {
      setMessage("");
    }, 4000);
  };

  const handleEditOrRunSavedFilter = (shouldRunFilter, filtersOptions?) => {
    if (shouldRunFilter) {
      const isSelectedSavedFilter = filtersOptions?.id === chosenFilter?.id;
      const filtersToServer = { ...filtersOptions };

      // if we clicked on the selected filter we should reset the active filter
      if (isSelectedSavedFilter) {
        const keys = Object.keys(filtersToServer);
        for (const key of keys) {
          filtersToServer[key] = null;
        }
      }

      setRunFilter(!isSelectedSavedFilter);
      setChosenFilter(filtersToServer);
      submitFilter(filtersToServer);
    } else {
      closeSavedFilterComponent();
      setChosenFilter(filtersOptions);
    }
  };

  const [message, setMessage] = useState("");

  const clearFilter = () => {
    filterOptionInit();

    setRunFilter(false);

    // if the filter is already run we want to clear it
    if (runFilter) {
      const resetChosenFilter = { ...chosenFilter };
      const keys = Object.keys(resetChosenFilter);
      for (const key of keys) {
        resetChosenFilter[key] = null;
      }
      setChosenFilter(resetChosenFilter);
      submitFilter(resetChosenFilter);
    }

    if (filterType === FilterType.reportType) {
      setReportDate(null);
      setUpdateDate(null);
    } else {
      setRegistrationDate(null);
      setLastReportUpdate(null);
    }
  };

  const SavedFilterList = dbRequest?.savedFilters?.map(
    (savedFilter: savedFilterType) => (
      <div className="flexContainer space-between" key={savedFilter.id}>
        <button
          type="button"
          className="saved-filter-button"
          onClick={() => {
            handleEditOrRunSavedFilter(true, prepareFilterOptions(savedFilter));
          }}
        >
          {runFilter && savedFilter?.id === chosenFilter?.id && (
            <div className="dot active" />
          )}
          <Table size={16} />
          <span className="defualt-padding-horizontal">
            {savedFilter.name || savedFilter.filterName}
          </span>
        </button>
        <button type="button" className="display-on-mouse">
          <PencilSquare
            className="editFilter"
            size={16}
            onClick={() => {
              handleEditOrRunSavedFilter(
                false,
                prepareFilterOptions(savedFilter)
              );
              openTheMultiCollapseFormOutSide();
            }}
          />
          <Trash size={16} onClick={() => deleteFilterFromDB(savedFilter)} />
        </button>
      </div>
    )
  );

  if (dbRequest?.isLoading) {
    return <div>{t("saving")}...</div>;
  }

  if (dbRequest?.isError) {
    return <div>{t("FailedToSaveFilter")}</div>;
  }

  return (
    <div>
      {SavedFilterList?.length ? SavedFilterList : t("noData")}
      {message}
    </div>
  );
};
export default SavedFilters;
